// LVGL LV_OPA constants (0-255 range)
export const OPA_0    = 0;
export const OPA_10   = 25;
export const OPA_20   = 51;
export const OPA_30   = 76;
export const OPA_40   = 102;
export const OPA_50   = 127;
export const OPA_60   = 153;
export const OPA_70   = 178;
export const OPA_80   = 204;
export const OPA_90   = 230;
export const OPA_COVER = 255;

function strip(hex) {
    // Strip alpha channel and normalise to 6-char '#rrggbb'
    return '#' + hex.replace('#', '').slice(0, 6);
}

function hexToRgb(hex) {
    const h = strip(hex).slice(1);
    return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
}

function rgbToHex(r, g, b) {
    return '#' + [r, g, b]
        .map(v => Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, '0'))
        .join('');
}

// lv_color_mix(c1, c2, mix)  →  c1 * mix/255 + c2 * (1 - mix/255)
export function mix(hex1, hex2, ratio255) {
    const [r1, g1, b1] = hexToRgb(hex1);
    const [r2, g2, b2] = hexToRgb(hex2);
    const r = ratio255 / 255;
    return rgbToHex(r1 * r + r2 * (1 - r), g1 * r + g2 * (1 - r), b1 * r + b2 * (1 - r));
}

// lv_color_lighten(c, lvl)  →  mix(white, c, lvl)
export function lighten(hex, lvl) { return mix('#ffffff', hex, lvl); }

// lv_color_darken(c, lvl)   →  mix(black, c, lvl)
export function darken(hex, lvl) { return mix('#000000', hex, lvl); }

// Strip alpha suffix so colours from settings (#rrggbbaa) work transparently
export function normalise(hex) { return strip(hex ?? '#000000'); }
